/* eslint-disable */
import React, { useState, useEffect, useContext } from 'react';
import Card from '../../components/card.component';
import { useParams } from 'react-router-dom';
import paquetesFunction from '../paquetes/paquetes.functions';
import tableDetalle from './detalle.table';
import DataTable from 'react-data-table-component';
import utils from '../../utils/utils.functions';
import { ConfigContext } from '../../context/config.context';
import PrinterGuide from './imprimir/guia.printer';
import PrinterFull from './imprimir/full.printer';
import PrinterGuideV2 from './imprimir/guia_version_2.printer';
import PrinterGuideV3 from './imprimir/guia_version_3_etiquetadora';
import PrinterGuideV4 from './imprimir/guia_version_4_etiquetadora';
import PrinterGuideV5 from './imprimir/guia_version_5_etiquetadora';
import Modal from '../../components/modal/modal.component';
import EmailGuide from '../../components/email.component';
import AnularGuia from '../../components/anular.component';
import GuiaExterna from '../../components/guiaexterna.component'; 
import {
  Row,
  Col
} from 'react-bootstrap';
import moment from 'moment';
import pad from 'pad';
import Destinatario from '../../components/modificar/destinatario.component';
import BultosMod from '../../components/modificar/bultos.component';
import DetalleMod from '../../components/modificar/detalle.component';
import PagoModal from '../../components/pagoexterno.component';
import PrinterFullEntrega from '../master/imprimir/full.printer';
import {
  faPaperPlane,
  faTimesCircle,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  DropdownButton,
  Dropdown
} from 'react-bootstrap';
import numeral from 'numeral';
import DetalleBoleta from '../facturacion/detalle_boleta/detalleboleta.modal';
import FacturacionComponent from '../facturacion/facturacion.component';
import { ConfigContextUtils } from '../../context/contextUtils.context';
import table from '../../views/facturacion/facturacion.table';

const ComponentPrinterGuia =  {
  printerguidev2: PrinterGuideV2,
  printerguidev1: PrinterGuide,
  printerguidev3: PrinterGuideV3,
  printerguidev4: PrinterGuideV4,
  printerguidev5: PrinterGuideV5,
}


const Detalle = () => {

  const { config } = useContext(ConfigContext);
  const { setPreloader } = useContext(ConfigContextUtils);

  const [load, setLoad] = useState(false);
  const [data, setData] = useState(null);
  const [modalShow, setModalShow] = useState(false);
  const [modalType, setModalType] = useState(0);
  const [detallePago, setDetallePago] = useState(false);
  const [modalPago, setModalPago] = useState(false);
  const [modalEdit, setModalEdit] = useState({
    visible: false,
    tipo: '-',
  });

  const { uuid } = useParams();

  const openModalEdit = (tipo) => {
    setModalEdit({
      tipo: tipo,
      visible: !modalEdit.visible
    })
  }

  const pagoInit = () => {
    setModalPago(!modalPago);
  }

  const detailGuide = () => {
    setPreloader(true);

    paquetesFunction.detalleGuia({ uuid }).then((response) => {
      setData(response.data);
      setLoad(true);
      setPreloader(false);
    });
  }
 
  const openModal = (type) => {
    setModalShow(!modalShow);
    setModalType(type);
  }

  useEffect(() => {
    detailGuide();
  },[])

  const refrescardatos = () => {
    detailGuide();
    setModalShow(false);
  }

  const renderPrinterGuia = () => {
    if (typeof ComponentPrinterGuia[config.printer_guia.componente] !== "undefined") {
      return React.createElement(ComponentPrinterGuia[config.printer_guia.componente], {
        data: data,
        empresa: config,
        prefijo: config.prefijo_correlativo_guia,
        disabled: !data.anulado ? false : true,
        showPrefixGuide: utils.obtenerValorPermiso('USE_PREFIX_TYPE_SENDING', config.operaciones)
      });
    }
  }

  const calculoTotalMonto = (seguros, total) => {
    let totalSeguro = 0;
    seguros.map(sg => {
       totalSeguro += sg.monto_seguro
    });

    return totalSeguro + total;
  }

  const calculateTotalesBultos = (dataBultos) => {

    let pesoTotal = 0;
    let ft3Total = 0;

    data.bultos.map((item) => {
        pesoTotal = pesoTotal + item.peso;
        ft3Total = ft3Total + item.pie;
    });

    return  <>
            <div className="box-info-bultos">
                <small>Peso Total</small>
                <div className="monto-text amount-good">{ numeral(pesoTotal).format('0.00') }</div>
            </div>
            <div className="box-info-bultos">
                <small>Total Ft3</small>
                <div className="monto-text amount-good">{ numeral(ft3Total).format('0.00') }</div>
            </div>
            </>
  }

  let showPrefixGuide = utils.obtenerValorPermiso('USE_PREFIX_TYPE_SENDING', config.operaciones);
  
  return (
    <>
     {load ? 
       <>
       <Row>
        <Col lg={6}>
          <Card>
            <Row>
              <Col lg={6}>
                <div>
                  <small>Guia realizado por</small>
                  <div>({pad(4,data.gestor.id,'0')}) {data.gestor.username}</div>
                </div>
              </Col>
            </Row>
          </Card>
        </Col>
        {data.guia_pendiente || data.anulado ? 
        <Col lg={6}>
        <Card>
            <Row>
              <Col className="d-flex justify-content-center">
                <div>
                  <h3 style={{ color: 'red', fontWeight: 'bold' }}> { data.anulado ? 'ANULADO' : 'GUIA RESERVADA'}</h3>
                </div>
              </Col>
            </Row>
          </Card>
        </Col>
        : null }
       </Row>
       <Row className="mt-2">
        <Col>
          <Card>
            <Row>
              <Col>
                <div>
                  <small>Registrado</small>
                  <div>{moment(data.createdAt).format('DD/MM/YYYY H:s')}</div>
                </div>
                <div>
                  <small>Guia master</small>
                  <div>{pad(8,data.master_guia.id,'0')}</div>
                  <div>{data.master_guia.description.toUpperCase()}</div>
                </div>
                <div>
                  <small>Tipo de envio</small>
                  <div>{data.master_guia.rel_tipos.description}</div>
                </div>
                <div>
                  <small>Guia paquete</small>
                  <div>{config !== null ? `${showPrefixGuide ? data.master_guia.rel_tipos.prefijo : config.prefijo_correlativo_guia}-${data.guia_paquete}` : null }</div>
                </div>
                <div>
                  <small>Bultos totales</small>
                  <div>{data.bultos.length}</div>
                </div>
                <div>
                  <small>Estado de la guia</small>
                  <div>{data.anulado === 0 ? 'Activa' : 'Anulado'}</div>
                </div>
                {data.anulado !== 0 ?
                  <div>
                    <small>Fecha de anulación</small>
                    <div>{moment(data.fecha_anulacion).format('DD/MM/YYYY H:s')}</div>
                  </div> : null
                }
                <div>
                  <small>Guia externa asignada</small>
                  <div>{data.guide_assigned_courier ? `(${data.externo.nombre}) ${data.guide_assigned_courier}` : 'N/A'}</div>
                </div>
              </Col>
              <Col>
                <div>
                  <small>Envia</small>
                  <div>{data.cliente.name}</div>
                   <div>{data.cliente.phone}</div>
                </div>
                <div>
                  <small>Recibe</small>
                  <div>{data.cliente_receptor_nombre}</div>
                </div>
                <div>
                  <small>Identificación</small>
                <div>{data.cliente_receptor_identificacion}</div>
                </div>
                <div>
                  <small>Telefono</small>
                  <div>{data.cliente_receptor_telefono}</div>
                </div>
                <div>
                  <small>Dirección de entrega</small>
                  <div className="d-flex flex-column">
                    <div>{data.cliente_receptor_direccion_entrega.toUpperCase()}</div>
                    <div>{data.estado_guia.estado !== '-' && data.estado_guia.estado.toUpperCase()} {data.ciudad_guia.ciudad !== '-' && data.ciudad_guia.ciudad.toUpperCase()} {data.pais_guia.country.toUpperCase()}</div>
                  </div>
                </div>
              </Col>
            </Row>
            {config.tipo === 1 ?
            <Row>
              <Col className="d-flex justify-content-end">
                <button 
                  onClick={() => openModalEdit('destinatario') } 
                  type="button" className="btnx btnx-warn mr-2" disabled={data.anulado ? true : false}>
                    Editar destinatario
                </button>
                <GuiaExterna 
                  data={data}
                  onUpdate={() => detailGuide()}
                  disabled={data.anulado ? true : false}
                />
              </Col>
            </Row>
            : null}
          </Card>
        </Col>
      </Row>

      {data.descripcion_carga !== null && data.descripcion_carga !== '' ?
        <Row className="mt-3">
          <Col>
            <Card>
              <Row>
                <Col>
                  <div style={{ fontSize: 17, fontWeight: 'bold' }}>Descripción carga</div>
                  <div>
                  {data.descripcion_carga}
                  </div>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      : null }


      <Row className="mt-3">
        <Col>
          <Card>
            <Row>
              <Col>
                <DataTable
                  title={'Bultos detalle'}
                  customStyles={tableDetalle.customStyles}
                  columns={tableDetalle.colummnsBultos(utils.obtenerValorPermiso('UNIT_BOX_GUIDE', config.operaciones))}
                  data={data.bultos}
                  dense={true}
                  pagination={true}
                  paginationPerPage={5}
                />
              </Col>
            </Row>
            {config.tipo === 1 ?
            <Row>
              <Col className="d-flex">
                {calculateTotalesBultos(data.bultos)}
              </Col>
              <Col className="d-flex justify-content-end" style={{ alignItems: 'flex-end' }}>
                <button style={{ height: 35 }} onClick={() => openModalEdit('bultos') } type="button" className="btnx btnx-warn" disabled={data.anulado ? true : false}>Editar bultos</button>
              </Col>
            </Row>
            : null}
          </Card>
        </Col>
      </Row>

      <Row className="mt-3">
        <Col>
          <Card>
            <Row>
              <Col>
              {data.detalle.length ? 
                <DataTable
                  title={'Detalle productos'}
                  customStyles={tableDetalle.customStyles}
                  columns={tableDetalle.colummnsWithFunc()}
                  data={data.detalle}
                  dense={true}
                  pagination={true}
                  paginationPerPage={5}
                />
                :
                <h4>No posee detalle de productos</h4>
              }
              </Col>
            </Row>
            {config.tipo === 1 && data.detalle.length ?
              <Row>
                <Col className="d-flex justify-content-end">
                  <button onClick={() => openModalEdit('detalle') } type="button" className="btnx btnx-warn" disabled={data.anulado ? true : false} >Editar detalle</button>
                </Col>
              </Row>
            : null}
          </Card>
        </Col>
      </Row>
      {!data.guia_pendiente ? 
      <Row className="mt-3">
        <Col>
          <Card>
            <Row>
              <Col>
              {data.seguro_guia.length ?
               <DataTable
                  title={'Seguro'}
                  customStyles={tableDetalle.customStyles}
                  columns={tableDetalle.columnsSeguro()}
                  data={data.seguro_guia}
                  dense={true}
                  pagination={false}
                  paginationPerPage={10}
                />
                :
                  <h4>Guia no asegurada por el cliente</h4>
                }
              </Col>
            </Row>
          </Card>
        </Col>
      </Row> : null }

      {data.guia_pendiente && !data.anulado ? 
        <Row className="mt-3">
          <Col>
            <Card>
              <Row>
                <Col>
                    <div>
                      <div className="title-mediun">Guia con monto reservado</div>
                      <div style={{ fontSize: 16, flexDirection: 'column', display: 'flex' }}>
                        <div>{`$${utils.formatMoney(data.boleta_guia.monto_total, 0, '.')}`}</div>
                        <div>{moment(data.boleta_guia.fecha).add(1, 'days').format('DD/MM/YYYY')}</div>
                      </div>
                    </div>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      : null}

      <Row className="mt-3">
        <Col>
          <Card>
            <Row>
              <Col lg={8}>
              {data.guia_pendiente && !data.anulado ? 
                <>
                  <button onClick={pagoInit} type="button" className="btnx btnx-warn">Generar recibo de pago</button> 
                  <Modal show={modalPago} size={'xl'}>
                    <Row className="mt-3">
                        <Col lg={12}>
                        <Card>
                            <FacturacionComponent
                              btnClose={true}
                              onClose={pagoInit}
                              dataClient={data.cliente}
                              isGuide={true}
                              dataFullGuide={{ ...data, complete_payment: true }}
                              isReserved={true}
                              refresh={detailGuide}
                              dataReserverGuide={data}
                              fromOrigin="detail_package"
                            />
                        </Card>
                        </Col>
                      </Row>
                  </Modal>
                </>
              : 
              <> 
                 <DetalleBoleta 
                      boletaId={data.boleta_guia.id}
                      btnText="Ver detalle del pago"
                      pageGuide={true}
                      isRefresh={true}
                      updateBol={detailGuide}
                  />
                  <div className="ml-1">
                    <small>Total pagado</small>
                    <div><b>{table.calculatePaymentWithDocument(data.boleta_guia)} {config.currency}</b></div>
                  </div>
                </>
                } 
              </Col>
              <Col className="d-flex justify-content-end">
              {data !== null && config !== null ? 
                <DropdownButton  size="sm" variant="secondary" title="Opciones guia">
                  {renderPrinterGuia()}
                  <PrinterFullEntrega 
                      campo="guia_id"
                      masterId={data.id}
                      isButton={false}
                      disabled={!data.anulado && !data.guia_pendiente ? false : true}
                      texto="Orden de entrega"
                      showPrefixGuide={utils.obtenerValorPermiso('USE_PREFIX_TYPE_SENDING', config.operaciones)}
                  />
    
                   <PrinterFull
                    data={data}
                    empresa={config}
                    prefijo={config.prefijo_correlativo_guia}
                    currency={config.currency}
                    disabled={!data.anulado ? false : true}
                    showPrefixGuide={utils.obtenerValorPermiso('USE_PREFIX_TYPE_SENDING', config.operaciones)}
                  />

                  <Dropdown.Item onClick={() => openModal(0)} disabled={!data.anulado ? false : true }> 
                      <FontAwesomeIcon icon={faPaperPlane} /> Re-envia guia al correo
                  </Dropdown.Item>
                  {/*
                  <Dropdown.Item onClick={() => openModal(1)} disabled={!data.guia_finalizada && !data.anulado ? false : true }> 
                      <FontAwesomeIcon icon={faTimesCircle} color={'red'}/> Anular guia
                  </Dropdown.Item>*/}
                </DropdownButton>
               : null}
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
      <Modal show={modalShow}>
        <Card>
            <div>
              { modalType === 0 ?
                <EmailGuide onClose={() => setModalShow(false)} show={modalShow} codigo={data.uuid} email={data.cliente.email} />
              : modalType === 1 ?
                <AnularGuia codigo={data.boleta_guia.id} show={modalShow} onConfirm={() => refrescardatos()} onClose={() => setModalShow(false)}/>
              :null }
            </div>
        </Card>               
      </Modal>

      <Modal show={modalEdit.visible}>
        <Card>
          {modalEdit.tipo === 'destinatario' ? 
            <Destinatario 
              onClose={() => openModalEdit(null)}
              data={data}
              show={modalEdit.visible}
              onUpdate={() => detailGuide()}
            />
          : modalEdit.tipo === 'bultos' ?
            <BultosMod
              data={data}
              onClose={() => openModalEdit(null)}
              onUpdate={() => detailGuide()}
            />      
          : modalEdit.tipo === 'detalle' ? 
            <DetalleMod data={data}
              onClose={() => openModalEdit(null)}
              onUpdate={() => detailGuide()}
            />
          : null }
        </Card>
      </Modal>
      </>
      : null}
      </>
    )
}

export default Detalle;